import { render } from "./GraphTwo.vue?vue&type=template&id=bf963cea&scoped=true"
import script from "./GraphTwo.vue?vue&type=script&lang=js"
export * from "./GraphTwo.vue?vue&type=script&lang=js"

import "./GraphTwo.vue?vue&type=style&index=0&id=bf963cea&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf963cea"]])

export default __exports__